import React, { Component } from 'react';

class Loader extends Component {

	render() {
		const spinnerUrl = 'https://my.kabbalah.com/ticket-widget/media/spinner.svg';
		let { width } = this.props;
		if (!width) {
			width = '26px';
		}		
		
		return (
			<span>
				{this.props.message &&
					<span>{this.props.message}</span>
				}
				<img 
					src={spinnerUrl} 
					width={width}
					alt=""
					style={{ marginTop: "-20%", marginBottom: "-20%" }}
				/>
			</span>
		);
	}

}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js